<ng-container *ngIf="!done">
    <div class="cas-form-floating push-up-2">
        <acabim-data-display-multicolumn
            [title]="'Actions to be archived'"
            [dataMap]="actionInfo"
            [columnHeaders]=""></acabim-data-display-multicolumn>
    </div>
    <div class="cas-action-buttons cas-action-buttons-bottom">
        <button (click)="cancel($event)">Cancel</button>
        <button class="cas-button-action cas-button-right" (click)="submit()">Archive</button>
    </div>
</ng-container>

<ng-container *ngIf="done">
    <div class="cas-info">
        <h4>Done!</h4>
        <p>You have successfully archived {{parcel.length}} actions.</p>
        <button class="cas-button-action" (click)="onComplete()">Close</button>
    </div>
</ng-container>
